import { render, staticRenderFns } from "./ModalOptionSelection.vue?vue&type=template&id=22d0bb0b&scoped=true&"
import script from "./ModalOptionSelection.vue?vue&type=script&lang=js&"
export * from "./ModalOptionSelection.vue?vue&type=script&lang=js&"
import style0 from "./ModalOptionSelection.vue?vue&type=style&index=0&id=22d0bb0b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d0bb0b",
  null
  
)

export default component.exports